import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import { OBJECT_TYPES } from 'src/tpbp-configuration/models/models.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'
import { FIELD_RULES } from 'src/tpbp-core/models/fields/fieldRules.const'

const donationFields: FieldInterface[] = [
  {
    key: 'date',
    originKey: 'date',
    type: FIELD_TYPES.date,
    rule: FIELD_RULES.isMandatory,
  },
  {
    key: 'donationType',
    originKey: 'donation_type',
    type: FIELD_TYPES.string,
    rule: FIELD_RULES.isMandatory,
  },
  {
    key: 'donationTypeLabel',
    originKey: 'donation_type_label',
    type: FIELD_TYPES.string,
    rule: FIELD_RULES.isOptional,
  },
  {
    key: 'donationMode',
    originKey: 'donation_mode',
    type: FIELD_TYPES.string,
  },
  {
    key: 'donationModeLabel',
    originKey: 'donation_mode_label',
    type: FIELD_TYPES.string,
    rule: FIELD_RULES.isOptional,
  },
  {
    key: 'nature',
    originKey: 'nature',
    type: FIELD_TYPES.string,
    rule: FIELD_RULES.isMandatory,
  },
  {
    key: 'natureLabel',
    originKey: 'nature_label',
    type: FIELD_TYPES.string,
  },
  {
    key: 'usufructReserve',
    originKey: 'usufruct_reserve',
    type: FIELD_TYPES.boolean,
    rule: FIELD_RULES.isOptional,
  },
  {
    key: 'usufructReverse',
    originKey: 'usufruct_reverse',
    type: FIELD_TYPES.object,
    objectType: 'BooleanOrNull',
    objectTypePath: 'src/tpbp-core/models/common/utils.types.ts',
    rule: FIELD_RULES.isOptional,
  },
  {
    key: 'valueAtDonationDate',
    originKey: 'value_at_donation_date',
    type: FIELD_TYPES.number,
    rule: FIELD_RULES.isOptional,
  },
  {
    key: 'valueAtDeathDate',
    originKey: 'value_at_death_date',
    type: FIELD_TYPES.number,
    rule: FIELD_RULES.isOptional,
  },
]

const donationRelations: RelationInterface[] = [
  {
    key: '_donator',
    originKey: 'donator',
    objectType: OBJECT_TYPES.person,
  },
  {
    key: '_donation_donees',
    originKey: 'donation_donees',
    objectType: OBJECT_TYPES.donationDonee,
    isMultiple: true,
  },
  {
    key: '_donation_goods',
    originKey: 'donation_goods',
    objectType: OBJECT_TYPES.donationGood,
    isMultiple: true,
  },
]

export { donationFields, donationRelations }
